import { useEffect, useRef } from "react";

export function useAutoLogout({ enabled, timeoutMinutes, onLogout }) {
  const timer = useRef(null);
  const timeout = timeoutMinutes * 60 * 1000;

  const resetTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(async () => {
      try {
        await onLogout();
      } catch (err) {
        console.error("Erro no logout automático:", err);
      }
    }, timeout);
  };

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const events = [
      "click",
      "keydown",
      "mousemove",
      "touchstart",
      "visibilitychange",
    ];
    const handler = () => resetTimer();

    events.forEach((evt) => document.addEventListener(evt, handler));
    resetTimer();

    return () => {
      clearTimeout(timer.current);
      events.forEach((evt) => document.removeEventListener(evt, handler));
    };
  }, [enabled, timeoutMinutes, onLogout]);

  return { resetTimer };
}
